function GeneralLoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/mypage/general/${view}.vue`
    );
}

function BusinessLoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/mypage/business/${view}.vue`
    );
}

const mypageRoutes = [
  /* 마이페이지 - 일반 */

  // 회원 정보
  {
    path: '/mypage/general',
    name: 'MypageGeneral',
    component: GeneralLoadView('mypageGeneral'),
    meta: {
      category: ['마이페이지', '회원정보'],
      empcategory: ['USR'],
      isLnb: true,
    },
  },

  // 주차요금 감면 정보
  {
    path: '/mypage/discount/info',
    name: 'mypageDiscountInfo',
    component: GeneralLoadView('mypageDiscountInfo'),
    meta: {
      category: ['마이페이지', '주차요금 감면 정보'],
      empcategory: ['USR'],
      isLnb: true,
    },
  },

  // 무정차 정산 내역
  {
    path: '/mypage/nonstop/history',
    name: 'mypageNonstopHistory',
    component: GeneralLoadView('mypageNonstopHistory'),
    meta: {
      category: ['마이페이지', '무정차 정산 내역'],
      empcategory: ['USR'],
      isLnb: true,
    },
  },

  /* 마이페이지 - 사업자 */

  // 정보 확인
  {
    path: '/mypage/business/check',
    name: 'MypageBusinessCheck',
    component: BusinessLoadView('mypageBusinessCheck'),
    meta: {
      category: ['마이페이지', '회원정보'],
      empcategory: ['BSN'],
    },
  },

  // 회원정보
  {
    path: '/mypage/business/update',
    name: 'MypageBusinessUpdate',
    component: BusinessLoadView('mypageBusinessUpdate'),
    meta: {
      category: ['마이페이지', '회원정보'],
      empcategory: ['BSN'],
      isLnb: true,
    },
  },

  // 웹 할인 신청
  {
    path: '/mypage/business/webdiscount',
    name: 'mypageBusinessWebdiscount',
    component: BusinessLoadView('mypageBusinessWebdiscount'),
    meta: {
      category: ['마이페이지', '웹 할인 신청'],
      empcategory: ['BSN'],
      isLnb: true,
    },
  },

  // 웹 할인 내역
  {
    path: '/mypage/business/webdiscount/history',
    name: 'mypageBusinessWebdiscountHistory',
    component: BusinessLoadView('mypageBusinessWebdiscountHistory'),
    meta: {
      category: ['마이페이지', '웹 할인 내역'],
      empcategory: ['BSN'],
      isLnb: true,
    },
  },
];

export default mypageRoutes;
